import { colorPalette } from "../../../shared/utils/constants";

export const customStyles = {
  text: {
    width: "100%",
    display: "flex",
    fontFamily: "'Bebas Neue', sans-serif",
    justifyContent: "center",
    flexWrap: "wrap",
    color: colorPalette.sectionTitle,
  },
  formCard: {
    boxShadow: 3,
    borderRadius: 3,
    p: 4,
    background: colorPalette.white,
  },
  infoCard: {
    boxShadow: 3,
    borderRadius: 3,
    p: 3,
    background: colorPalette.white,
  },
  sectionTitle: {
    fontFamily: "'Bebas Neue', sans-serif",
    color: colorPalette.sectionTitle,
    mb: 2,
  },
  infoCardTitle: {
    fontFamily: "'Bebas Neue', sans-serif",
    fontWeight: 600,
    color: colorPalette.sectionTitle,
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    borderRadius: "50%",
    background: `${colorPalette.headerBackground}20`,
    flexShrink: 0,
  },
  contactLabel: {
    fontSize: "0.875rem",
    color: "text.secondary",
    mb: 0.5,
  },
  contactIcon: {
    color: colorPalette.headerBackground,
    fontSize: "1.5rem",
  },
  contactValue: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.95rem",
    color: colorPalette.headerBackground,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  contactLink: {
    fontFamily: "'Barlow', sans-serif",
    fontWeight: 400,
    fontSize: "0.95rem",
    color: colorPalette.headerBackground,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};
